import { useState } from "react";
import { Modal, Table, InputNumber, Button } from "antd";
import { audioNotification } from "../Common/Notifications/audioNotification";

// csv_data is headerless (row 0 is the header row). Pull distinct dates from the "Date" column.
const extractDates = (csvData = []) => {
  if (!csvData.length) return [];
  const header = csvData[0].map(c => String(c ?? "").replace(/^﻿/, "").trim().toLowerCase());
  const dateIdx = Math.max(header.indexOf("date"), 0);
  return [...new Set(csvData.slice(1).map(r => r[dateIdx]).filter(Boolean).map(String))];
};

export const SnapCountDialog = ({ open, csvData, onSubmit }) => {
  const [rows, setRows] = useState(() =>
    extractDates(csvData).map(date => ({ key: date, date, offense: 0, defense: 0 }))
  );

  const setCell = (date, field, value) =>
    setRows(prev => prev.map(r => (r.date === date ? { ...r, [field]: value } : r)));

  const isValid = rows.length > 0 && rows.every(
    r => Number.isInteger(r.offense) && r.offense >= 0 && Number.isInteger(r.defense) && r.defense >= 0
  );

  const numberCell = field => (value, record) => (
    <InputNumber
      min={0}
      precision={0}
      value={value}
      onChange={v => setCell(record.date, field, v)}
      style={{ width: "100%" }}
    />
  );

  const columns = [
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Offense", dataIndex: "offense", key: "offense", render: numberCell("offense") },
    { title: "Defense", dataIndex: "defense", key: "defense", render: numberCell("defense") },
  ];

  return (
    <Modal
      open={open}
      title="Projected Snap Counts"
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={720}
      style={{ top: 120 }}
    >
      <div style={{ marginBottom: 16 }}>
        <p style={{ fontSize: "14px", marginBottom: "16px" }}>
          Enter projected offense and defense snap counts for each training date.
        </p>
      </div>
      <Table
        columns={columns}
        dataSource={rows}
        size="small"
        pagination={rows.length > 15 ? {
          pageSize: 15,
          showSizeChanger: false,
          showTotal: (total) => `Total ${total} days`,
          position: ['bottomLeft']
        } : false}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16, marginBottom: 16 }}>
        <Button
          type="primary"
          disabled={!isValid}
          onClick={() => {
            onSubmit(rows.map(({ date, offense, defense }) => ({ date, offense, defense })));
            audioNotification.success({
              message: "Projected snap counts recorded",
              description: "Please click submit to proceed.",
            });
          }}
        >
          Submit Snap Counts
        </Button>
      </div>
    </Modal>
  );
};
